import { ReactNode } from "react";
import { MaterialService } from "../../util/services/material";
import { cloneObj } from "../../util/varibles/global";
import { ICapability, IErrorForm, IStorage, IVessel } from "../../util/varibles/interface";
import { createFastContext } from "../createFastContext";

interface IState {
    vessel: IVessel | Partial<IVessel>
    file?: any
    materials: {
        loading: boolean
        data: any[]
    }
    error?: {
        [key: string]: any
        capabilities: {
            [index: string]: { [key: string]: IErrorForm }
        }
        storages: {
            [index: string]: { [key: string]: IErrorForm }
        }
        equipments: {
            [index: string]: { [key: string]: IErrorForm }
        },
    }
}

const {
    Provider,
    useStore: useEditVessel,
    setStore: setEditVessel,
    getStore: getEditVessel,
    callEvent: callEventEditVessel
} = createFastContext<IState, {
    getMaterials(): void,
    updateCapability(index: number, props: Partial<ICapability>): void
    updateStorage(index: number, props: Partial<IStorage>): void
    deleteCapability(index: number): void
    deleteStorage(index: number): void
}>({
    vessel: {},
    materials: {
        loading: false,
        data: []
    }
});

const EditVesselProvider = ({ children }: {
    children: ReactNode,
} & Partial<IState>) => {

    return <Provider
        event={{
            getMaterials: ({ set }) => {
                set({ materials: { loading: true, data: [] } });
                MaterialService.getTypes()
                    .then(rs => {
                        set({ materials: { loading: false, data: rs } })
                    })
                    .catch(() => {
                        set({ materials: { loading: false, data: [] } })
                    })
            },
            updateCapability: (index, value, { set }) => {
                set(({ vessel }) => {
                    const capabilities = cloneObj((vessel.capabilities || []));
                    capabilities[index] = { ...capabilities[index], ...value }
                    return { vessel: { ...vessel, capabilities } }
                })
            },
            deleteCapability: (index, { set }) => {
                set(({ vessel }) => {
                    const capabilities = cloneObj((vessel.capabilities || []));
                    capabilities.splice(index, 1)
                    return { vessel: { ...vessel, capabilities } }
                })
            },
            updateStorage: (index, value, { set }) => {
                set(({ vessel }) => {
                    const storages = cloneObj((vessel.storages || []));
                    storages[index] = { ...storages[index], ...value }
                    return { vessel: { ...vessel, storages } }
                })
            },
            deleteStorage: (index, { set }) => {
                set(({ vessel }) => {
                    const storages = cloneObj((vessel.storages || []));
                    storages.splice(index, 1)
                    return { vessel: { ...vessel, storages } }
                })
            }
        }}
    >
        {children}
    </Provider>
}


export { callEventEditVessel, EditVesselProvider, getEditVessel, setEditVessel, useEditVessel };

